import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Image} from 'semantic-ui-react';
import {injectIntl, intlShape} from 'react-intl';

import BasicModal from "../../common/BasicModal";
import ErrorDisplay from "../../common/ErrorDisplay";
import {ReactionGifs} from 'components/common/ReactionGifs';
import ValidationErrorTable from 'components/break/ValidationErrorTable';

const PublishBreakModal = (props) => (
    <BasicModal header={ props.intl.formatMessage({id: `${props.intlPrefix}.modal.header.${(props.successful ? 'success' : 'error')}` }) }
                specialType={ (!props.successful ? "caution-modal" : "success-modal") + " fadeInUp animResponse"}
                dimmer={'inverted'}
                modalSize="small"
                open={props.isModalOpen}
                onClose={props.handleClose}
                >

        <Grid centered>
          <Image src={ReactionGifs[!props.successful ? 'NEGATIVE' : 'POSITIVE'][Math.floor(Math.random() * ReactionGifs[props.validationErrors ? 'NEGATIVE' : 'POSITIVE'].length)]}/>
        </Grid>

        { props.validationErrors ? <ValidationErrorTable errors={props.validationErrors} /> : "" }

        <ErrorDisplay error={props.creationError}/>
    </BasicModal>
);

PublishBreakModal.propTypes = {
    intl: intlShape,
    handleClose: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    intlPrefix: PropTypes.string
};

PublishBreakModal.defaultProps = {
    intlPrefix: 'general'
};

export default injectIntl(PublishBreakModal);



// WEBPACK FOOTER //
// ./public/components/break/BreakPublish/PublishBreakModal.jsx